<template>
  <div class="achievementpopup-container" id="achievement-popup">
    <transition-group name="list" class="popup-success-base" enter-active-class="animated fadeInDown"
                      leave-active-class="animated fadeOutUp">
      <div class="popup success-base" :key="key+'p'" v-for="(success,key) in successbase">
        <span>{{ success.name }}</span> <span>+ {{ success.pts }} pt.s</span>
      </div>
    </transition-group>

    <transition-group name="list" class="popup-success" enter-active-class="animated fadeInDown"
                      leave-active-class="animated zoomOut">
      <div class="popup success" v-for="(success,key) in successes" :key="key+'p'">
        <h2 class="title">{{ success.name }}</h2>
        <img :src="success.icon" alt="">
        <p class="subtile">+ {{ success.pts }} pt.s</p>
        <span class="insta_tags">{{ success.insta_tags }}</span>
        <p class="content" v-html="success.content">{{ success.content }}</p>
        <div class="close" @click="closePopup(key)">FERMER</div>
      </div>
    </transition-group>
  </div>
</template>

<script>
import {store} from '../../../store/store';

import 'hooper/dist/hooper.css';
import {mapActions, mapState} from 'vuex';

export default {
  name: 'AchievementPopup',
  data() {
    return {
      successbase: null,
      successes: null

    }
  },
  computed: {
    ...mapState(['successBase', 'success'])
  },
  methods: {
    ...mapActions([
      "addMask",
      'removeSuccessBaseAction',
      'removeSuccess'
    ]),
    closePopup(key) {
      this.successes.splice(key, 1)
      this.removeSuccess()

    },
    removeSuccessBase() {
      setTimeout(() => {
        // this.successbase.shift()
        this.removeSuccessBaseAction()

        if (this.successbase.length > 0) {

          this.removeSuccessBase()

        }

      }, 2000)


    },
    getSuccesBase() {
      this.successbase = this.successBase
    },

  },
  mounted() {

    if (this.successBase) {
      setTimeout(
          this.getSuccesBase,
          800
      )
      setTimeout(
          this.removeSuccessBase,
          1000
      )
    }

    if (this.success) {
      this.successes = this.success
    }


  },
  updated() {

  }
}

</script>

<style scoped>

.popup-container {
  position: absolute;
  top: env(safe-area-inset-top);
  left: 0;
  width: 100%;
  height: 100vh;
  display: flex;
}

.popup-success-base {
  position: absolute;
  top: env(safe-area-inset-top);
  left: 35%;
  width: 30%;
  height: initial;
  display: flex;
  flex-direction: column;
  margin: 0;
  transition: .3s;
}

.popup.success-base {
  width: 100%;
  margin-top: 10px;
  border-radius: 5px;
  min-height: initial;
  flex-direction: row;
  justify-content: space-around;
  background: var(--main-color);
  color: #fff;
  padding: 10px;
  transition: .3s;

}

.popup {
  position: relative;
  margin: auto;
  background: #fff;
  border-radius: 10px;
  /*border:2px solid #00d6ff;*/
  min-width: 30%;
  min-height: 10vh;
  padding: 10px 10px 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.popup-success {
  position: absolute;
  top: 0;
  left: 20%;
  width: 60%;
}

.popup.success {
  width: 100%;
  position: absolute;
}

.popup h2 {
  text-align: center;
  font-family: "Bebas Neue";
  color: #00d6ff;
  font-weight: 200;
  letter-spacing: 2px;
  margin: 0;
}

.popup p {
  text-align: center;
  font-family: Poppins;
  font-size: 12px;
}


.close {
  color: #fff;
  background: var(--main-red-color);
  transition: .3s;
  padding: 5px 20px;
  border: 1px solid var(--main-red-color);
  text-transform: uppercase;
  font-family: "Bebas Neue";
  font-weight: 200;
  font-size: 18px;
  letter-spacing: 2px;
  border-radius: 5px;
  position: absolute;
  bottom: -10px
}

.close:hover {
  cursor: pointer;

}


/*    EXCEPTION DESKTOP  */
@media screen and (min-width: 750px) {
  .popup {
    margin-top: calc(50% - 30%);

  }
}


/*    EXCEPTION MOBILE*/
@media screen and (max-width: 750px) {

  .popup-success-base,
  .popup-success,
  .popup {
    min-width: 80%;
  }

  .popup-success-base,
  .popup-success {
    left: 10%;
  }


}

</style>
